<template>
  <v-container>
    <!-- Diálogo de éxito -->
    <v-dialog v-model="dialogSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Cita confirmada exitosamente</p>
          <p class="text-center">Gracias por confirmar tu cita</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de error -->
    <v-dialog v-model="dialogError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">Error</p>
          <p class="text-center">{{ errorMessage }}</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/" color="primary" class="container">Volver al inicio</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Estado de carga -->
    <div v-if="loading" class="text-center mt-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p class="font-weight-light mt-4">Cargando información de la cita...</p>
    </div>

    <!-- Mostrar datos de la hora para confirmar -->
    <div v-else-if="hour && !dialogSuccess && !dialogError">
      <div class="text-center mb-4">
        <h2 class="primary--text">Confirmar tu cita</h2>
        <p class="grey--text">Por favor revisa los datos y confirma tu asistencia</p>
      </div>

      <div class="d-flex justify-center mb-4">
        <professional-avatar
          v-bind:id-professional="(hour.professional || {}).id"
          v-bind:size="80"
        ></professional-avatar>
      </div>
      <p class="text-center primary--text title">{{(hour.professional || {}).fullName}}</p>

      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Especialidad</v-list-item-title>
            <v-list-item-subtitle>{{(hour.specialty || {}).name}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Fecha</v-list-item-title>
            <v-list-item-subtitle>{{hour.date}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Hora</v-list-item-title>
            <v-list-item-subtitle>{{hour.start}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-4"></v-divider>

      <!-- Botón para confirmar -->
      <div class="text-center">
        <v-btn
          color="success"
          large
          :loading="confirming"
          :disabled="confirming"
          @click="executeConfirm"
        >
          <v-icon left>mdi-check</v-icon>
          Confirmar mi cita
        </v-btn>
      </div>

      <p class="text-center grey--text mt-4 caption">
        Al confirmar, nos ayudas a organizar mejor la agenda médica.
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    hour: {},
    loading: true,
    confirming: false,
    dialogSuccess: false,
    dialogError: false,
    errorMessage: ""
  }),
  methods: {
    // Obtener datos de la hora sin ejecutar confirmación
    async getHourData() {
      try {
        if (!this.$route.params.token) {
          throw new Error("Falta token en URL");
        }
        // Llamar al endpoint sin execute para solo obtener datos
        let { data } = await this.$http.post("confirmhour", {
          actionToken: this.$route.params.token
        });
        this.hour = data.hour || data;
        this.loading = false;
      } catch (err) {
        this.errorMessage = (err.response && err.response.data && err.response.data.msg) || err.message || "Error al cargar la información";
        this.dialogError = true;
        this.loading = false;
      }
    },

    // Ejecutar la confirmación
    async executeConfirm() {
      try {
        this.confirming = true;
        let { data } = await this.$http.post("confirmhour", {
          actionToken: this.$route.params.token,
          execute: true
        });
        this.hour = data.hour || data;
        this.dialogSuccess = true;
      } catch (err) {
        this.errorMessage = (err.response && err.response.data && err.response.data.msg) || err.message || "Error al confirmar la cita";
        this.dialogError = true;
      } finally {
        this.confirming = false;
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "Confirmar cita") {
        this.hour = {};
        this.loading = true;
        this.dialogSuccess = false;
        this.dialogError = false;
        this.errorMessage = "";
        this.getHourData();
      }
      if (from.name == "Confirmar cita") {
        this.hour = {};
      }
    }
  },
  mounted() {
    this.getHourData();
  }
};
</script>

<style>
</style>
